var removeMultipleSpaces = function removeMultipleSpaces(value) {
  if (value === undefined) return undefined;
  if (!value) return "";
  var splittedValue = value.split(" ");
  return splittedValue.reduce(function (acc, curr) {
    return (acc + " " + curr).trim();
  }, "");
};
export default removeMultipleSpaces;